var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.isLoading)?_c('preloader'):_vm._e(),(!_vm.isLoading)?_c('bracket',{staticClass:"tournament-bracket",attrs:{"rounds":_vm.rounds},scopedSlots:_vm._u([{key:"player",fn:function(ref){
var player = ref.player;
return [_vm._v(" "+_vm._s(player.name)+" ")]}}],null,false,2469036928)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }